import React, { useMemo } from 'react'
import WorkoutEquipmentForm from './_form'

export default function WorkoutEquipmentAdd (props) {
  const data = useMemo(() => ({ enableSearch: false, active: false, shopAvailable: false }), [])
  return (
    <WorkoutEquipmentForm data={data} {...props} />
  )
}